import {Component, ViewChild, OnInit, AfterViewInit, ElementRef, Input} from '@angular/core';
import {Http} from '@angular/http';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BatchPaymentsService} from '../../../models/batch-payments/batch-payments.service';


declare let $: JQueryStatic | any;

import 'jquery-serializejson';
import 'jquery-validation';
import {DebtsModel} from '../../../models/debts/debts.model';
import {IClientModel} from '../../../models/clients/clients.model';


@Component({
    selector: 'manage-payments-modal',
    templateUrl: 'manage-payments-modal.template.html',
    styleUrls: []
})

export class ManagePaymentsModalComponent implements OnInit, AfterViewInit {

    @Input()
    public debt = new DebtsModel();

    @Input()
    public client;

    constructor(
        private route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        private batchPaymentsService: BatchPaymentsService
    ) {



    }

    ngOnInit() {

    }

    ngAfterViewInit() {

    }


    // ===========================================================
    // Functions
    // ===========================================================


    loadData() {



    }


    // ===========================================================
    // Actions
    // ===========================================================



    public setFunded() {

    }


    public close() {

    }

    public applyTopup() {

    }
}


// WEBPACK FOOTER //
// ./src/app/modules/debt-account/manage-payments-modal/manage-payments-modal.component.ts